export default "__VITE_ASSET__D37JJots__"